import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { VehicleOdometerChangeReasonEnum } from '../enums/vehicle-odometer-change-reason.enum';

/**
 * Vehicle odometer tracking DTO
 */
export class VehicleOdometerTrackingDto extends BaseDto {
	sourceSubject!: AppSubjectEnum;
	@TransformInt()
	sourceId!: number;
	changeReason!: VehicleOdometerChangeReasonEnum;
	@TransformInt()
	changeReferenceId?: number;
	notes?: string;
	@TransformInt()
	vehicleId!: number;
	@TransformInt()
	value!: number;
	@TransformDate()
	recordedAt!: Date;
}
